export * from "-!../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../node_modules/vue-loader/lib/index.js??vue-loader-options!./App.vue?vue&type=template&id=3d42d4d8&"


//////////////////
// WEBPACK FOOTER
// ./src/App.vue?vue&type=template&id=3d42d4d8&
// module id = 75
// module chunks = 0